import { saveAs } from 'file-saver';
import { DepartTimeService } from '../../Services/depart-time.service';
import { GeneralSettingsService } from '../../Services/general-settings.service';
import { CalendarService } from '../../Services/calendar.service';
import { Component, OnInit, group } from '@angular/core';
import { ArrivalService } from '../../Services/arrival.service';
import { Response } from '@angular/http';


import * as $ from 'jquery';
import { CourseService } from '../../Services/course.service';

@Component({
  selector: 'app-calendar-form',
  template: require('./calendar-form.component.html'),
  styles: [require('./calendar-form.component.css')]
})

export class CalendarFormComponent implements OnInit {

  // groups: any[] = [];
  calendar: any = {};
  groupKeys: any[] = [];
  loading: boolean = false;
  beginDate: Date = new Date();
  endDate: Date = new Date();
  today: Date = new Date()
  arrivalList: any[] = [];
  departList: any[] = [];

  modalInfo: any = {
    departTime: "",
    course: { longDescrption: "" },
    arrival: ""
  }

  CurrentSelectedCourseID = -1;
  CurrentSelectedCourseKm:number = 0;
  CurrentSelectedCourseHm:number = 0;
  CurrentSelectedCourseTitle:string = "";

  constructor(
    private calendarService: CalendarService,
    private generalSettingsService: GeneralSettingsService,
    private arrivalService: ArrivalService,
    private departTimeService: DepartTimeService,
    private courseService:CourseService
  ) { }

  ngOnInit() {
    // console.log("NgOnInit")
    // $(document).ready(function(){
    //   console.log("Done loading");
    //   (<any>$('[data-toggle="popover"]')).popover(); 
    //   (<any>$('.autoHidePopover')).popover().click(function () {
    //         setTimeout(function () {
    //             (<any>$('.autoHidePopover')).popover('hide');
    //         }, 10000);
    //     });
    // });

    this.loading = true;

    this.departTimeService.getAllDepartTimes().subscribe(x => {
      this.departList = x;
      // console.log(this.departList)
    })

    this.arrivalService.getAllArrivals().subscribe(x => {
      this.arrivalList = x;
      // console.log(x); 
    });

    this.calendarService.getAllCalendars().subscribe(x => {
      x.forEach((element: any) => {

        let groupName = element.group.name;
        if (!this.calendar.hasOwnProperty(groupName)) {
          this.calendar[groupName] = [];
        }

        var arrival = this.arrivalList.find(x => x.date == element.date);

        if (arrival) {
          element.arrival = arrival.location;
        }
        else {
          element.arrival = ""
        }
        this.calendar[groupName].push(element);

        var departTime = this.departList.find(x => ((element.date >= x.startDate) && (element.date <= x.endDate)));

        if (departTime) {
          element.departTime = departTime.leaveHour
        }
        else {
          element.departTime = ""
        }

        // console.log(element)

      });
      this.groupKeys = Object.keys(this.calendar).sort(
        function (a, b) {
          var nameA = a.toLowerCase(), nameB = b.toLowerCase();
          if (nameA < nameB) //sort string ascending
            return -1;
          if (nameA > nameB)
            return 1;
          return 0; //default return value (no sorting)

        });
      this.loading = false;

      // console.log(this.calendar);
    });

    this.generalSettingsService.getBeginEndCalendarDates().subscribe(x => {
      if (x) {
        this.beginDate = x[0].calenderBeginDate;
        this.endDate = x[0].calenderEndDate;
      }
    });


  }
  showModal(courseInfo: any) {
    this.modalInfo = courseInfo;
    (<any>$('#infoModal')).modal();
  }

  createZipFile(group: string) {
    this.calendarService.downloadFile(group).subscribe((res: Response) => {
      // console.log(res)
      // console.log(res.headers!.get('content-disposition'));
      this.saveFileFromBlob(res);
    });
  }

  private saveFileFromBlob(res: Response) {
    if (res.headers) {
      var header = "";
      header = res.headers.get('content-disposition') || "";
      var startIndex = header.indexOf("filename=") + 9; // Adjust '+ 9' if filename is not the right one.
      var endIndex = header.indexOf(";", startIndex);
      var filename = header.substring(startIndex, endIndex);
      // console.log("filename: " + filename)
      saveAs(res.blob(), filename);
    }
  }

  checkToday(d:Date){
   
     var t = new Date(d);



     if ((t.getDate() == this.today.getDate()) && (t.getMonth() == this.today.getMonth()) && (t.getFullYear == this.today.getFullYear)){
      return "#9ABDAD"
     }

     if (t.getMonth() == this.today.getMonth()){
       return "#E6E6C2"
     }
    
  }

  SetCurrentCourseID(id:number){
    this.CurrentSelectedCourseID = id;

    this.courseService.getCourse(this.CurrentSelectedCourseID).subscribe( (res:any)=>{
      console.log(res);
      
      this.CurrentSelectedCourseKm = res.distance;
      this.CurrentSelectedCourseHm = res.altitudeMeters;
      this.CurrentSelectedCourseTitle = res.name;

      if (res.reverse){
        this.CurrentSelectedCourseTitle += " (omgedraaid)"
      }

    })

  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/calendar-form/calendar-form.component.ts